module.exports = __webpack_public_path__ + "media/images/suppliers/affinitybiosciences-2e57532d80bcab8e12b5ede8e8ab117b.png";